// HealthSafetyAlerts.js
import React from 'react';
import AlertTypePage from './AlertTypePage';

const HealthSafetyAlerts = () => {
    const alertTypes = ["Health & Safety", "Thermal Comfort"];
    return <AlertTypePage alertType={alertTypes} title="Health & Safety Alerts" />;
};

export default HealthSafetyAlerts;